// extracted by mini-css-extract-plugin
export var autoExpand = "_2q-8";
export var container = "_2q-7";
export var containerWidth = "_2q-5";
export var disabled = "_2q-2";
export var error = "_2q-3";
export var fullWidth = "_2q-6";
export var inputWrapper = "_2q-0";
export var small = "_2q-1";
export var textarea = "_2q-4";